import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileDropdown",
  filters: {
    boardName(boardId, boards) {
      var _boards$boardId;
      return (_boards$boardId = boards[boardId]) == null ? void 0 : _boards$boardId.name;
    }
  },
  props: {
    linkedProfiles: {
      type: Array,
      required: true
    },
    selectedLinkedProfile: {
      type: Object,
      required: true
    },
    boards: {
      type: Object,
      required: true
    }
  },
  computed: {
    linkedProfilesWithoutCurrent() {
      var _context;
      return _filterInstanceProperty(_context = this.linkedProfiles).call(_context, ({
        clientProfileId
      }) => clientProfileId !== this.selectedLinkedProfile.clientProfileId);
    },
    isMultiLinked() {
      return this.linkedProfilesWithoutCurrent.length > 0;
    }
  },
  methods: {
    handleProfileSelection(clientProfileId) {
      this.$emit("select", clientProfileId);
    }
  }
});